import { useState } from 'react';

import Form from './Form';
import Finish from './Finish';


export default function Info(props) {

  const [step, setstep] = useState(1);
  const [validation] = useState(true)

    const [formData, setFormData] = useState({
      
      MoreInfo: "Customer wants more information.",

      FirstName: "",
      LastName: "",
      BusinessName: "",
      ContactMethod: "",
      Email: "",
      Phone: "",

    })

    // function for going to next step by increasing step state by 1
    const nextStep = () => {
      setstep(step + 1);
    };

    // function for going to next step by increasing step state by 0.5
    const nextHalfStep = () => {
      setstep(step + 0.5);
    };

    // function for going to previous step by decreasing step state by 1
    const prevStep = () => {
      setstep(step - 1);
    };

    // function for going to previous step by decreasing step state by 1
    const prevHalfStep = () => {
      setstep(step - 0.5);
    };

    // handling form input data by taking onchange value and updating our previous form data state
    const handleInputData = input => e => {
      // input value from the form
      let { value } = e.target;
      if (e.target.type === 'checkbox') {
        value = e.target.checked
      }

      //updating for data state taking previous state and then adding new value to create new object
      setFormData(prevState => ({
        ...prevState,
        [input]: value
      }));
    }

    const changeVal = (key, val) => {
      setFormData(prevState => ({
        ...prevState,
        [key]: val
      }));
    }

    switch (step) {
      // case 1 to show stepOne form and passing nextStep, prevStep, and handleInputData as handleFormData method as prop and also formData as value to the fprm
      case 1:
        return (
          <div className="App-container">
            <Form nextStep={nextStep} nextHalfStep={nextHalfStep} handleFormData={handleInputData} values={formData} validation = {validation}></Form>
          </div>
        );
      case 2:
        return (
          <div className="App-container">
            <Finish values={formData} ></Finish>
          </div>
        )
    }
    }

    // <Final values = {formData}></Final>